module.exports = __webpack_public_path__ + "static/media/det.1dd8d8a8.png";